import { GroupMembership } from "../models/interfaces";

export function isSameDay(date1: Date | string, date2: Date | string): boolean {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
}

export function isInFuture(date: Date | string): boolean {
    if (!date) return false;
    const today = new Date();
    return date > today;
}

export function isToday(date: Date | string): boolean {
    if (!date) return false;
    const d = new Date(date);
    const today = new Date();
    return (
      d.getDate() === today.getDate() &&
      d.getMonth() === today.getMonth() &&
      d.getFullYear() === today.getFullYear()
    );
}

export function isInGroupTimePeriod(date: Date | string, groupMemberships: GroupMembership[]): boolean {
    let isInTimePeriod: boolean = false;

    if (!date || groupMemberships === null || groupMemberships.length === 0) return isInTimePeriod;

    // First check if there is a favorite group in the list of groups
    const favoriteGroup = groupMemberships.find(g => g.isFavorite);
    if (favoriteGroup) {
      // Check if the date is within the favorite group's tracking period
      isInTimePeriod = date >= new Date(favoriteGroup.groups.trackingPeriodStart) && date <= new Date(favoriteGroup.groups.trackingPeriodFinish);
    }

    return isInTimePeriod;
}